import React from 'react'
import { Box, Typography, Link } from '@mui/material'

interface Airline {
    name: string
    href: string
}

interface TopAirlinesProps {
    title: string
    airlines: Airline[]
}

export const TopAirlines: React.FC<TopAirlinesProps> = ({ title, airlines }) => {
    return (
        <Box sx={{ px: 3, py: 2 }}>
            <Typography
                variant="subtitle1"
                sx={{
                    fontWeight: 700,
                    mb: 2,
                    fontSize: '14px',
                    color: 'text.primary'
                }}
            >
                {title}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1.5
                }}
            >
                {airlines.map((airline, index) => (
                    <Link
                        key={index}
                        href={airline.href}
                        target="_parent"
                        sx={{
                            color: 'text.secondary',
                            textDecoration: 'none',
                            fontSize: '12px',
                            '&:hover': {
                                color: 'primary.main',
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        {airline.name}
                    </Link>
                ))}
            </Box>
        </Box>
    )
}

export type { TopAirlinesProps }
